import { connect } from 'react-redux';
import { selectExperiments } from '@noths/polaris-client-user-configuration';
import { updateFavourite } from '@noths/polaris-client-user-favourites';
import getConfig from 'next/config';

import { PDP_MVP_ABC_VARIANT_2 } from 'src/constants/experiments';
import { ReduxApplicationState } from 'src/redux/combinedReducer';
import { submitPersonalisationForm } from 'src/redux/personalisation';
import { selectFavouriteProduct } from 'src/redux/selectors';
import { AppThunkDispatch } from 'src/redux/store';
import { NextConfig } from 'src/types';
import { AddToBasketButton } from '../components/AddToBasketButton';
import { actions } from '../modules/slice';

const nextConfig = getConfig() as NextConfig;

const mapStateToProps = (state: ReduxApplicationState) => ({
  product: selectFavouriteProduct(state),
  shouldShowDeliveryBlock: !selectExperiments(state)?.includes(PDP_MVP_ABC_VARIANT_2),
});

const mapDispatchToProps = (dispatch: AppThunkDispatch) => ({
  onBuyGiftCard: () => dispatch(actions.onBuyGiftCard()),
  updateFavourite: (productCode: number) => dispatch(updateFavourite({ productCode, nextConfig })),
  submitPersonalisationForm: () => dispatch(submitPersonalisationForm()),
});

export const AddToBasketButtonContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(AddToBasketButton);
